@if (formGroup !== undefined) {
  <parkour-checkbox [formControl]="formGroup.controls.checked" [disabled]="geblokkeerd">
    <ng-container [ngTemplateOutlet]="content" />
  </parkour-checkbox>
} @else {
  <parkour-checkbox [disabled]="geblokkeerd">
    <ng-container [ngTemplateOutlet]="content" />
  </parkour-checkbox>
}

<ng-template #content>
  <parkour-profiel-block [profielData]="teamlid" />
</ng-template>
